import React, { useMemo } from "react";
import { InputText } from "@loanbossinc/component-library";

import { StyledOR } from "../line-item-comparison/styles";
import { FieldListItem } from "../fieldsEditValue/usedFieldsList";
import { ComparisonCard, GroupsWrapper, StyledPropertySelectWrapper } from "./styles";

const ComparisonGroups = (props) => {
  const {
    multiplePropertiesComparisonFields,
    multiPropComparisonSubLineItemNames,
    singlePropertyComparisonCards,
    isMultipleProperties,
    setNewLineItemSelections,
    properties,
    fields
  } = props;

  const groups = useMemo(() => isMultipleProperties ? multiplePropertiesComparisonFields : singlePropertyComparisonCards, [fields]);

  const handleInputNameChange = (event, index) => {
    if (!isMultipleProperties) {
      const updatedCards = singlePropertyComparisonCards.map((card, idx) => {
        if (idx === index) {
          return { ...card, name: event.target.value };
        }

        return card;
      });
      setNewLineItemSelections({ singlePropertyComparisonCards: updatedCards });
    } else {
      const updatedCardNames = multiPropComparisonSubLineItemNames.map((name, idx) => {
        if (idx === index) {
          return event.target.value;
        }

        return name;
      });
      setNewLineItemSelections({ multiPropComparisonSubLineItemNames: updatedCardNames });
    }
  };

  const getFieldsUsedInGroups = (isMultipleProperties, group, properties, fields) => {
    const fieldsPropertiesUsed = [];
    if (isMultipleProperties) {
      group.forEach((subGroup) => {
        if (subGroup.selectedField) {
          const usedForPropertyName = subGroup.propertyName;
          const fieldRef = fields.find((field) => field.id === subGroup.selectedField.id);
          fieldsPropertiesUsed.push({ field: fieldRef, propertyName: usedForPropertyName });
        }
      });
    } else {
      if (group.selectedField) {
        const fieldRef = fields.find((field) => field.id === group.selectedField.id);
        fieldsPropertiesUsed.push({ field: fieldRef, propertyName: properties[0].name });
      }
    }

    return fieldsPropertiesUsed;
  };

  return (
    <GroupsWrapper>
      {fields && groups.map((group, index) => {
        return (
          <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            <ComparisonCard>
              <InputText
                variant="filled"
                id={`sub-line-item-name${index}`}
                name="sub-item-name"
                label="Sub-line item name"
                value={isMultipleProperties ? multiPropComparisonSubLineItemNames[index] : group.name}
                onChange={(e) => {
                  handleInputNameChange(e, index);
                }}
                fullWidth
                style={{ marginBottom: "1em" }}
              />
              {getFieldsUsedInGroups(isMultipleProperties, group, properties, fields).map((fieldProperty) => {
                return (
                  <StyledPropertySelectWrapper key={fieldProperty.field.id}>
                    <FieldListItem fieldProperty={fieldProperty} {...props} properties={properties} />
                  </StyledPropertySelectWrapper>
                );
              })}
            </ComparisonCard>
            {index < singlePropertyComparisonCards.length - 1 && <StyledOR value="OR" />}
          </div>
        );
      })}
    </GroupsWrapper>
  );
};

export default ComparisonGroups;
